<div class="reminderModal__splitInputField">
  <span class="reminderModal__viewLabel">{{ 'repeat' | ppTranslate }}</span>
  <span class="reminderModal__viewValue">{{ formattedText }}</span>
</div>
